var userAgentStyles = require("./user-agent-styles");
var supportedListStyles = require("./list-marker");

var defaultLineHeight = 1.16;
var pxToPtRatio = getPxToPtRatio();

var roleMap = {
    ul: "list",
    ol: "list",
    p: "p",
    h: "h",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    h7: "h7",
    td: "table-cell",
    th: "table-heading",
};

/*eslint-disable no-undef */
function getPxToPtRatio() {
    return 0.75;
}
/*eslint-enable no-undef */

function pxToPt(px) {
    if (!px) return 0;
    if (typeof px === "string") {
        px = parseFloat(px);
        if (isNaN(px)) return 0;
    }
    if (typeof px === "number") return px * pxToPtRatio;
    return 0;
}

function ptToPx(pt) {
    if (!pt) return 0;
    if (typeof pt === "string") {
        pt = parseFloat(pt);
        if (isNaN(pt)) return 0;
    }
    if (typeof pt === "number") return pt / pxToPtRatio;
    return 0;
}

function getStyleAttrStyles(e) {
    var props = e.style.cssText.split(";");
    props = props
        .filter(function (p) {
            return p.indexOf(":") >= 0;
        })
        .map(function (p) {
            return p
                .split(":")
                .map(function (str) {
                    return str.trim();
                })
                .slice(0, 2);
        });

    return props.reduce(function (obj, p) {
        obj[p[0]] = p[1];
        return obj;
    }, {});
}

function parseDirShorthand(str) {
    if (!str) return {};

    var parts = str.trim().split(/\s+/g);

    if (parts.length < 2) parts[1] = parts[0];
    if (parts.length < 3) parts[2] = parts[0];
    if (parts.length < 4) parts[3] = parts[1];

    return {
        top: parts[0],
        right: parts[1],
        bottom: parts[2],
        left: parts[3],
    };
}

function parseBorderShorthand(str) {
    if (!str) return {};

    var parts = str.trim().split(/\s+/g);

    return {
        width: parts[0],
        style: parts[1],
        color: parts[2],
    };
}

var colorReg = {
    rgb: /rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i,
    rgba: /rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+(\.\d+)?)\s*\)/i,
    hex: /#([0-9a-f]{1,2})([0-9a-f]{1,2})([0-9a-f]{1,2})$/i,
};
function parseCssColor(c) {
    var match;

    if (Array.isArray(c)) return c; // Already parsed
    if (c === "transparent") return "none";
    if (colorReg.hex.test(c)) {
        match = c.match(colorReg.hex);
        return [parseInt(match[1], 16), parseInt(match[2], 16), parseInt(match[3], 16), 1];
    }
    if (colorReg.rgb.test(c)) {
        match = c.match(colorReg.rgb);
        return [Number(match[1]), Number(match[2]), Number(match[3]), 1];
    }
    if (colorReg.rgba.test(c)) {
        match = c.match(colorReg.rgba);
        return [Number(match[1]), Number(match[2]), Number(match[3]), match[4]];
    }

    return c;
}

var lenReg = {
    pt: /([-+]?[0-9]*\.?[0-9]+)pt/,
    px: /([-+]?[0-9]*\.?[0-9]+)px/,
    em: /([-+]?[0-9]*\.?[0-9]+)em/,
    rem: /([-+]?[0-9]*\.?[0-9]+)rem/,
    pct: /([-+]?[0-9]*\.?[0-9]+)%/,
};
function getLength(l, emSize) {
    var match;
    if (typeof l === "number") return l; // Already a number
    if (l === "auto") return l;
    if (l === "0") return 0;
    if (lenReg.rem.test(l)) {
        match = l.match(lenReg.rem);
        return Number(match[1]) * 12;
    }
    if (lenReg.em.test(l)) {
        match = l.match(lenReg.em);
        return Number(match[1]) * emSize;
    }
    if (lenReg.pt.test(l)) {
        match = l.match(lenReg.pt);
        return Number(match[1]);
    }
    if (lenReg.px.test(l)) {
        match = l.match(lenReg.px);
        return pxToPt(Number(match[1]));
    }
}
function getLengthOrPercentage(l, emSize) {
    const length = getLength(l, emSize);
    if (typeof length !== "undefined") return length;
    if (lenReg.pct.test(l)) {
        var match = l.match(lenReg.pct);
        return { pct: Number(match[1]) / 100 };
    }
}

function parseLineHeight(str) {
    if (str === "normal" || !str) return defaultLineHeight;

    var ret = Number(str);
    var match;

    if (!isNaN(ret)) return ret;
    if (lenReg.pct.test(str)) {
        match = str.match(lenReg.pct);
        return pxToPt(Number(match[1]) / 100);
    }
    return getLength(str, 1);
}

function parseFontSize(str, parentSize) {
    if (str === "inherit" || !str) return parentSize;

    var match;
    if (lenReg.pct.test(str)) {
        match = str.match(lenReg.pct);
        return Math.round((Number(match[1]) * parentSize) / 100);
    }
    return getLength(str, parentSize);
}

var vAlignValues = ["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"];
function parseVerticalAlign(str, emSize) {
    if (vAlignValues.indexOf(str) !== -1) return str;

    var match;
    if (lenReg.pct.test(str)) {
        match = str.match(lenReg.pct);
        return pxToPt(Number(match[1]) / 100);
    }
    return getLength(str, emSize);
}

function isListStyleType(str) {
    return typeof supportedListStyles[str] !== "undefined";
}
function parseListStyleShorthand(str) {
    if (typeof str !== "string") return {};
    var split = str.replace(/^\s+|\s+$/gi, "").split(/\s+/);
    var ret = {};
    split.forEach(function (part) {
        if (isListStyleType(part)) ret.type = part;
        else if (part === "inside" || part === "outside") ret.postition = part;
    });
    return ret;
}

function StyleManager(rules) {
    this.rules = userAgentStyles.concat(rules);
    this.rules.forEach(function (rule) {
        StyleManager.resolveShorthands(rule.declarations);
    });
    // console.log("RULES", this.rules.length);
}

StyleManager.ptToPx = ptToPx;
StyleManager.pxToPt = pxToPt;

var unitPatterns = {
    pt: /([-+]?[0-9]*\.?[0-9]+)pt/,
    px: /([-+]?[0-9]*\.?[0-9]+)px/,
    pct: /([-+]?[0-9]*\.?[0-9]+)%/,
    fr: /([-+]?[0-9]*\.?[0-9]+)fr/,
};
var units = ["pt", "px", "pct", "fr"];
StyleManager.getColumnWidths = function (columnsAttr) {
    var columnWidths = Array.isArray(columnsAttr) ? columnsAttr : columnsAttr.split(" ");
    columnWidths = columnWidths.map(function (str) {
        if (str.toLowerCase() === "auto") return { value: 1, unit: "fr" };

        var unit, match;
        for (var i = 0; i < units.length; i++) {
            unit = units[i];
            if (unitPatterns[unit].test(str)) {
                match = str.match(unitPatterns[unit]);
                return {
                    value: Number(match[1]),
                    unit: unit,
                };
            }
        }

        throw new TypeError("'" + str + "' is not a value column width unit.");
    });
    return columnWidths;
};

function extendStyles(styles, newStyles) {
    Object.keys(newStyles).forEach(function (key) {
        if (typeof newStyles[key] !== "undefined") styles[key] = newStyles[key];
    });
}

StyleManager.prototype.resolveRules = function (rootNode) {
    this.resolved = true;
    this.rules.forEach((rule) => {
        let matches;
        try {
            matches = Array.from(rootNode.querySelectorAll(rule.selector === "" ? "*" : rule.selector));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn("Problem matching selector: " + (rule.selector === "" ? "*" : rule.selector));
            return;
        }
        matches.forEach((el) => (el.__pdf_css_matches = (el.__pdf_css_matches || []).concat(rule)));
    });
};

StyleManager.prototype.getDeclarations = function (element) {
    let rules;
    if (this.resolved) {
        rules = element.__pdf_css_matches || [];
    } else {
        rules = this.rules.filter(function (rule) {
            return element.matches(rule.selector);
        });
    }
    return rules
        .concat([
            {
                selector: "",
                declarations: StyleManager.resolveShorthands(getStyleAttrStyles(element)),
            },
        ])
        .reduce(function (styles, rule) {
            if (rule.pseudo) {
                var pseudoKey = ":" + rule.pseudo;
                if (!styles[pseudoKey]) styles[pseudoKey] = {};
                extendStyles(styles[pseudoKey], rule.declarations);
            } else {
                extendStyles(styles, rule.declarations);
            }
            return styles;
        }, {});
};

var inheritedStyles = [
    "font-style",
    "font-weight",
    "font-size",
    "font-family",
    "line-height",
    "color",
    "text-align",
    "list-style-type",
    "list-style-position",
    "text-transform",
    "text-decoration",
    "letter-spacing",
    "overflow-wrap",
    "word-wrap",
];

StyleManager.resolveShorthands = StyleManager.prototype.resolveShorthands = function (styles) {
    // Shorthand
    var border = parseBorderShorthand(styles.border);
    var borderTop = parseBorderShorthand(styles["border-top"]);
    var borderRight = parseBorderShorthand(styles["border-right"]);
    var borderBottom = parseBorderShorthand(styles["border-bottom"]);
    var borderLeft = parseBorderShorthand(styles["border-left"]);
    var borderWidth = parseDirShorthand(styles["border-width"]);
    var borderColor = parseDirShorthand(styles["border-color"]);

    styles["border-top-width"] = styles["border-top-width"] || borderTop.width || borderWidth.top || border.width;
    styles["border-left-width"] = styles["border-left-width"] || borderLeft.width || borderWidth.left || border.width;
    styles["border-right-width"] =
        styles["border-right-width"] || borderRight.width || borderWidth.right || border.width;
    styles["border-bottom-width"] =
        styles["border-bottom-width"] || borderBottom.width || borderWidth.bottom || border.width;
    styles["border-top-color"] = styles["border-top-color"] || borderTop.color || borderColor.top || border.color;
    styles["border-left-color"] = styles["border-left-color"] || borderLeft.color || borderColor.left || border.color;
    styles["border-right-color"] =
        styles["border-right-color"] || borderRight.color || borderColor.right || border.color;
    styles["border-bottom-color"] =
        styles["border-bottom-color"] || borderBottom.color || borderColor.bottom || border.color;

    var padding = parseDirShorthand(styles.padding);
    var margin = parseDirShorthand(styles.margin);

    styles["padding-left"] = styles["padding-left"] || padding.left;
    styles["padding-right"] = styles["padding-right"] || padding.right;
    styles["padding-top"] = styles["padding-top"] || padding.top;
    styles["padding-bottom"] = styles["padding-bottom"] || padding.bottom;
    styles["margin-left"] = styles["margin-left"] || margin.left;
    styles["margin-right"] = styles["margin-right"] || margin.right;
    styles["margin-top"] = styles["margin-top"] || margin.top;
    styles["margin-bottom"] = styles["margin-bottom"] || margin.bottom;

    styles["background-color"] = styles["background-color"] || styles.background;

    var listStyle = parseListStyleShorthand(styles["list-style"]);

    styles["list-style-position"] = styles["list-style-position"] || listStyle.position;
    styles["list-style-type"] = styles["list-style-type"] || listStyle.type;

    return styles;
};

StyleManager.resolveStyles = StyleManager.prototype.resolveStyles = function (node) {
    var styles = (node.styles = node.styles || {});

    // Defaults
    if (!styles.display) styles.display = "inline";

    node.styles["list-style-position"] =
        node.styles["list-style-position"] || node.parentElement["list-style-position"];
    node.styles["list-style-type"] = node.styles["list-style-type"] || node.parentElement["list-style-type"];
};

function allCollapsed(children) {
    var childStyles;
    for (var i = 0; i < children.length; i++) {
        childStyles = children[i].computedStyles;
        if (!isBlockLike(children[i])) return false;
        if (!childStyles.collapseTopBottomMargins) return false;
    }
    return true;
}

function marginCollapse(a, b) {
    if (!a) return b;
    if (!b) return a;
    if (a > 0 && b > 0) return Math.max(a, b);
    if (a < 0 && b < 0) return Math.min(a, b);
    return a + b;
}

function isBlockLike(node) {
    return node.styles.display === "block" || node.styles.display === "list-item";
}

function isFirstChild(parent, node) {
    return Array.isArray(parent.children) && parent.children.length > 0 && parent.children[0] === node;
}

function isLastChild(parent, node) {
    return (
        Array.isArray(parent.children) &&
        parent.children.length > 0 &&
        parent.children[parent.children.length - 1] === node
    );
}

function collapseMargins(node, parent) {
    var lastMargin = 0;
    if (Array.isArray(node.children))
        node.children.forEach(function (child) {
            collapseMargins(child, node);
            if (lastMargin && isBlockLike(child) && child.computedStyles.marginTop) {
                child.computedStyles.marginTop = Math.max(0, child.computedStyles.marginTop - lastMargin);
            }
            lastMargin = child.computedStyles.marginBottom || 0;
            if (child.computedStyles.collapseTopBottomMargins) {
                child.computedStyles.marginBottom = 0;
            }
        });

    var styles = node.computedStyles;

    if (!Array.isArray(node.children) || node.children.length === 0 || allCollapsed(node.children)) {
        if (
            !styles.borderTopWidth &&
            !styles.borderBottomWidth &&
            !styles.paddingTop &&
            !styles.paddingBottom &&
            !styles.height
        ) {
            if (styles.marginTop && styles.marginBottom) {
                styles.marginBottom = styles.marginTop = marginCollapse(styles.marginTop, styles.marginBottom);
                styles.collapseTopBottomMargins = true;
            }
        }
    }

    if (!parent || styles.position === "absolute" || !isBlockLike(node) || parent.tagName === "pdf-columns") return;

    var parentStyles = parent.computedStyles;

    if (isFirstChild(parent, node) && !parentStyles.borderTopWidth && !parentStyles.paddingTop) {
        parentStyles.marginTop = marginCollapse(parentStyles.marginTop, styles.marginTop);
        styles.marginTop = 0;
    }
    if (isLastChild(parent, node) && !parentStyles.borderBottomWidth && !parentStyles.paddingBottom) {
        parentStyles.marginBottom = marginCollapse(parentStyles.marginBottom, styles.marginBottom);
        styles.marginBottom = 0;
    }
}

StyleManager.prototype.collapseMargins = function (node) {
    collapseMargins(node);
};

StyleManager.computeStyles = StyleManager.prototype.computeStyles = function (node) {
    var ret = {};

    // Get inherited styles
    var parentStyles = {
        size: 16,
    };
    if (node.parentElement) {
        parentStyles = node.parentElement.computedStyles;
    }
    inheritedStyles.forEach(function (prop) {
        if (!node.styles[prop] || node.styles[prop] === "inherit") node.styles[prop] = parentStyles[prop];
    });

    var fontSize = parseFontSize(node.styles["font-size"], parentStyles.size) || 16;
    var backgroundColor = parseCssColor(node.styles["background-color"]);

    // Block
    ret.borderTopWidth = getLength(node.styles["border-top-width"], fontSize);
    ret.borderLeftWidth = getLength(node.styles["border-left-width"], fontSize);
    ret.borderRightWidth = getLength(node.styles["border-right-width"], fontSize);
    ret.borderBottomWidth = getLength(node.styles["border-bottom-width"], fontSize);
    ret.borderTopColor = parseCssColor(node.styles["border-top-color"]);
    ret.borderLeftColor = parseCssColor(node.styles["border-left-color"]);
    ret.borderRightColor = parseCssColor(node.styles["border-right-color"]);
    ret.borderBottomColor = parseCssColor(node.styles["border-bottom-color"]);
    ret.borderBottomColor = Array.isArray(ret.borderBottomColor)
        ? ret.borderBottomColor.slice(0, 3)
        : ret.borderBottomColor;
    ret.borderLeftColor = Array.isArray(ret.borderLeftColor) ? ret.borderLeftColor.slice(0, 3) : ret.borderLeftColor;
    ret.borderRightColor = Array.isArray(ret.borderRightColor)
        ? ret.borderRightColor.slice(0, 3)
        : ret.borderRightColor;
    ret.borderBottomColor = Array.isArray(ret.borderBottomColor)
        ? ret.borderBottomColor.slice(0, 3)
        : ret.borderBottomColor;

    ret.background = Array.isArray(backgroundColor) ? backgroundColor.slice(0, 3) : backgroundColor;
    ret.backgroundOpacity = Array.isArray(backgroundColor) ? backgroundColor[3] || 1 : 1;
    ret.paddingLeft = getLength(node.styles["padding-left"], fontSize);
    ret.paddingRight = getLength(node.styles["padding-right"], fontSize);
    ret.paddingTop = getLength(node.styles["padding-top"], fontSize);
    ret.paddingBottom = getLength(node.styles["padding-bottom"], fontSize);
    ret.marginLeft = getLength(node.styles["margin-left"], fontSize);
    ret.marginRight = getLength(node.styles["margin-right"], fontSize);
    ret.marginTop = getLength(node.styles["margin-top"], fontSize);
    ret.marginBottom = getLength(node.styles["margin-bottom"], fontSize);
    // ret.width = getLength(node.styles.width, fontSize);
    // ret.height = getLength(node.styles.height, fontSize);
    ret.width = getLengthOrPercentage(node.styles.width, fontSize);
    ret.height = getLengthOrPercentage(node.styles.height, fontSize);

    // Absolute
    ret.position = node.styles.position;
    ret.top = getLengthOrPercentage(node.styles.top, fontSize);
    ret.left = getLengthOrPercentage(node.styles.left, fontSize);
    ret.right = getLengthOrPercentage(node.styles.right, fontSize);
    ret.bottom = getLengthOrPercentage(node.styles.bottom, fontSize);

    // Inline-block / Inline
    ret.verticalAlign = parseVerticalAlign(node.styles["vertical-align"], fontSize);

    var fontStyle = node.styles["font-style"];
    var fontWeight = node.styles["font-weight"];

    ret["font-style"] = node.styles["font-style"];
    ret["font-weight"] = node.styles["font-weight"];

    // Font styles
    ret.size = ret["font-size"] = fontSize;
    ret.lineHeight = ret["line-height"] = parseLineHeight(node.styles["line-height"], fontSize);
    ret.font = ret["font-family"] = node.styles["font-family"]; //'helvetica';
    ret.italic = fontStyle && (fontStyle.toLowerCase() === "italic" || fontStyle.toLowerCase() === "oblique");
    ret.bold =
        fontWeight &&
        (fontWeight.toLowerCase() === "bold" || fontWeight.toLowerCase() === "bolder" || Number(fontWeight) >= 600);
    ret.color = parseCssColor(node.styles.color);
    ret.color = Array.isArray(ret.color) ? ret.color.slice(0, 3) : ret.color;
    ret.align = ret["text-align"] = node.styles["text-align"];
    ret.letterSpacing = ret["letter-spacing"] = getLength(node.styles["letter-spacing"], fontSize);
    ret.transform = ret["text-transform"] = node.styles["text-transform"];
    ret["text-decoration"] = node.styles["text-decoration"];
    ret.underline = ret["text-decoration"] === "underline";

    ret.columnCount = node.styles["column-count"] ? Number(node.styles["column-count"]) : 1;
    ret.columnGap = getLength(node.styles["column-gap"], fontSize);
    ret.columnFill = getLength(node.styles["column-fill"], "balance");

    ret.overflowHidden = node.styles.overflow === "hidden";

    ret["list-style-type"] = node.styles["list-style-type"];
    ret["list-style-position"] = node.styles["list-style-position"];

    ret.overflowWrap = ret["overflow-wrap"] = node.styles["overflow-wrap"];
    ret.wordWrap = ret["word-wrap"] = node.styles["word-wrap"];

    node.computedStyles = ret;

    if (node.tagName && roleMap[node.tagName]) ret.role = roleMap[node.tagName];
    if (node.originalNode && node.originalNode.getAttribute) {
        if (node.originalNode.getAttribute("aria-hidden") === "true") {
            ret.role = "hidden";
        }
        if (node.originalNode.getAttribute("data-pdf-role")) {
            ret.role = node.originalNode.getAttribute("data-pdf-role");
        }
        if (node.originalNode.getAttribute("pdf-valign-first-page")) {
            ret.verticalAlignFirst = node.originalNode.getAttribute("pdf-valign-first-page");
        }
    }

    return ret;
};

module.exports = StyleManager;
